import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { useNavigate } from 'react-router-dom';
// Import komponentów MUI
import {
  Card,
  CardMedia,
  CardContent,
  Typography
} from '@mui/material';
import Main from 'layouts/Main';
import Container from 'components/Container';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import config from '../../config/config';

function Blog() {
  const { t } = useTranslation();
  const [posts, setPosts] = useState([]);
  const navigate = useNavigate();

  const getImageUrl = (imageData) => {
    return imageData?.formats?.small?.url
      ? `${config.CMS_BASE_URL}${imageData.formats.small.url}`
      : imageData?.formats?.thumbnail?.url
      ? `${config.CMS_BASE_URL}${imageData.formats.thumbnail.url}`
      : imageData?.url
      ? `${config.CMS_BASE_URL}${imageData.url}`
      : null;
  };

  useEffect(() => {
    fetch(`${config.CMS_BASE_URL}/api/posts?populate=*&sort=order:desc`)
      .then((res) => res.json())
      .then((data) => {
        setPosts(data?.data || []);
      })
      .catch((err) => {
        console.error('Failed to fetch posts:', err);
        setPosts([]);
      });
  }, []);

  return (
    <Main>
      <Container>
        {posts.length > 0 && (
          <Box>
            <Typography component="h1" sx={{ fontWeight: 'bold', fontSize: '36px', mb: 2 }}>
              {t('blog.title')}
            </Typography>
          </Box>
        )}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            gap: '32px',
            alignItems: 'stretch',
            justifyContent: 'flex-start',
          }}
        >
          {posts.length === 0 ? (
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '300px',
                textAlign: 'center'
              }}
            >
              <Typography 
                variant="h6" 
                color="text.secondary"
                sx={{ fontSize: '18px' }}
              >
                {t('blog.noPosts')}
              </Typography>
            </Box>
          ) : (
            posts
            .filter((post) => post.thumbnail)
            .filter((post) => post.PageName === 'components' || post.PageName === 'both')
            .map((post) => {
            const { id, title, header, thumbnail, documentId } = post;
            const imageUrl = getImageUrl(thumbnail); 

            return (
              <Card
                key={id}
                sx={{
                  maxWidth: 600,
                  width: {
                    xs: '100%', 
                    md: '31%'   
                  },
                  minWidth: {
                    xs: 'auto', 
                  },
                  boxSizing: 'border-box',
                  display: 'flex',
                  flexDirection: 'column',
                  cursor: 'pointer',
                  transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: '0 8px 25px rgba(0,0,0,0.15)'
                  }
                }}
                onClick={() => navigate(`/blog/${documentId}`)}
              >
                <CardMedia
                  component="img"
                  height="300"
                  image={imageUrl}
                  alt={thumbnail?.alternativeText}
                />
                <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                  <Typography gutterBottom variant="h4" component="h1" style={{ fontSize: '24px', fontWeight: 'bold', lineHeight: '1.4' }}>
                    {title}
                  </Typography>
                  <Typography 
                    variant="body1" 
                    color="text.secondary" 
                    component="div"
                    sx={{
                      flexGrow: 1,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      display: '-webkit-box',
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: 'vertical',
                    }}
                  >
                    <ReactMarkdown>{header}</ReactMarkdown>
                  </Typography>
                </CardContent>
              </Card>
            );
          }))}
        </Box>
      </Container>
    </Main>
  );
}

export default Blog; 